const STORAGE_KEY = 'demandjet.kanbanCollapsedColumns';

export function loadCollapsedColumnIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id) => typeof id === 'string');
  } catch {
    return [];
  }
}

export function saveCollapsedColumnIds(ids) {
  const next = Array.from(new Set((ids || []).filter((id) => typeof id === 'string')));
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore quota / private mode */
  }
  return next;
}

export function toggleCollapsedColumnId(ids, columnId) {
  const current = Array.isArray(ids) ? ids : [];
  if (current.includes(columnId)) {
    return saveCollapsedColumnIds(current.filter((id) => id !== columnId));
  }
  return saveCollapsedColumnIds([...current, columnId]);
}
